<div class="flex flex-col justify-center items-center text-sm border-2 border-lighterText mb-2 mt-4 rounded-2xl py-6 px-12 sm:px-24 md:px-48 w-full">
    <span class="font-semibold text-base mb-2 text-center">
      Möchten Sie eine Zusammenfassung der Einwilligung(en) und die Toyota Datenschutzinformation per E-Mail erhalten?
    </span>
  <div class="flex justify-center items-center gap-2 sm:gap-4 mt-2">
    <button
      class="text-white text-sm rounded-full py-2 px-2 h-[40px] w-[120px] sm:w-[150px]"
      [ngClass]="
      brand.isLexus()
      ? 'bg-lexusBlue hover:bg-lexusBlueDark'
      : 'bg-toyotaRed hover:bg-toyotaRedDark'
      "
      (click)="this.confirmWithMailInProgress = true; sendMailSummary.emit()"
    >
      @if (confirmWithMailInProgress) {
        <app-activity-spinner />
      }
      Ja
    </button>

    <button
      class="rounded-full text-sm border-2 border-black py-2 px-2 h-[40px] w-[120px] sm:w-[150px] items-center hover:bg-gray-100"
      (click)="this.confirmWithoutMailInProgress = true; withoutMailSummary.emit()"
    >
      @if (confirmWithoutMailInProgress) {
        <app-activity-spinner />
      }
      Nein
    </button>
  </div>
</div>
